import { Link, StaticQuery, graphql } from "gatsby"
import React from "react"
import logo from "../images/logo-4.svg"
import Imagebar from "../components/ImageBarCarosel"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faFacebook, faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faCaretRight, faCaretLeft, faTimes } from '@fortawesome/free-solid-svg-icons'

class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      menuActive: false,
      moreInfoActive: false,
      dropdownActive: false,
      dropdownId: null,
    }


    //bind this
    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleMoreInfo = this.toggleMoreInfo.bind(this)
  }


  toggleMenu() {
    this.setState({'menuActive': !this.state.menuActive})
  }

  toggleMoreInfo() {
    this.setState({'moreInfoActive': !this.state.moreInfoActive})
  }
  activateDropdown(id) {
    if(this.state.dropdownId === id) {
      if(this.state.dropdownActive) {
        this.setState({'dropdownActive': false})
      } else {
        this.setState({'dropdownActive': true})
      }
    } else {
      this.setState({'dropdownActive': true})
      this.setState({'dropdownId': id})
    }
  }
  deactivateDropdown() {
    this.setState({'dropdownActive': false})
  }
  dropdownSetClass(id) {
    if(this.state.dropdownActive && this.state.dropdownId === id) {
      return 'is-active'
    } else {
      return ''
    }
  }
  navClass() {
    if(this.state.dropdownActive) {
      return 'dropdown-active'
    } else {
      return ''
    }
  }
  render() {
    let Nav = (
      <>
      <StaticQuery 
        query={graphql`
          query {
            graphAPI {
              navigation {
                linkList {
                  ... on GRAPHAPI_ComponentMetaLink {
                    id
                    __typename
                    title
                    url
                  }
                  ... on GRAPHAPI_ComponentMetaDropdown {
                    id
                    __typename
                    title
                    links {
                      __typename
                      title
                      url
                      id
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (<>
          {data.graphAPI.navigation.linkList.map( link => {
            if(link.__typename === "GRAPHAPI_ComponentMetaLink") {
              return (
                <Link key={link.id} to={link.url} className="navbar-item">{link.title}</Link>
              )
            }
            else if(link.__typename === "GRAPHAPI_ComponentMetaDropdown") {
              return (
                  <div key={link.id} className={`navbar-item has-dropdown is-hoverable ${this.dropdownSetClass(link.id)}`}>
                  <div onClick={() => {this.activateDropdown(link.id)}} className="navbar-link">{link.title}</div>
                  <div className={`navbar-dropdown`}>
                    {link.links.map(sublink => (
                      <Link key={sublink.id} to={sublink.url} className="navbar-item">{sublink.title}</Link>
                    ))}
                  </div>
                  </div>
              )
            }
          })}
        </>)} 
        />
      </>
    )

    return (
    <>
    <header className={`${this.state.menuActive ? 'active' : ''}`}>
        <nav className="navbar">
          <div className="navbar-container" style={{ alignItems: "center" }}>
            <div className="navbar-brand  is-hidden-desktop ">
              <Link to="/" className="">
                <figure>
                  <img
                    src={logo}
                    alt="Fort Bend Municipal Utiliy District 23"
                    className="logo"
                  />
                </figure>
              </Link>
              <div className="aside-right" onClick={this.toggleMenu}>
                  <div className={`menu ${this.state.menuActive ? 'active' : ''}`}>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </div>
              </div>
            </div>
            <div className="navbar-menu">
              <div className="navbar-brand  is-hidden-touch is-adjusted">
                <Link to="/" className="">
                  <figure>
                    <img
                      src={logo}
                      alt="Fort Bend Municipal Utiliy District 23"
                      className="logo"
                    />
                  </figure>
                </Link>
              </div>
              <div className="navbar-end">
                {Nav}
              </div>
            </div>
          </div>
        </nav>
    {/* <div className="social-links">
        <a target="_blank" rel="noreferrer noopener" href="https://www.facebook.com/cypresscreekfire/" className="">
          <span className="icon"><FontAwesomeIcon icon={faFacebook} /></span>
        </a>
        <a target="_blank" rel="noreferrer noopener" href="https://www.instagram.com/cypresscreekfd/" className="">
          <span className="icon"><FontAwesomeIcon icon={faInstagram} /></span>
        </a>
    </div> */}
    </header>
    <Imagebar />
    </>
  )}
}


export default Header
